import { render, staticRenderFns } from "./DashboardOrganization.vue?vue&type=template&id=e19e517c&scoped=true&"
import script from "./DashboardOrganization.vue?vue&type=script&lang=js&"
export * from "./DashboardOrganization.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOrganization.vue?vue&type=style&index=0&id=e19e517c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19e517c",
  null
  
)

export default component.exports